import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";
import { Button } from "../components/ui";

const LoginBtnFC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <LoginButtonContainer>
      <Button
        variant="primary"
        size="medium"
        onClick={() => loginWithRedirect()}
      >
        Log In
      </Button>
    </LoginButtonContainer>
  );
};

const LoginButtonContainer = styled.div`
  display: block;
  position: static;
`;

export default LoginBtnFC;
